import React from 'react';
import {
  ContextualMenu, initializeIcons,
  CommandButton as V1CommandButton,
  DefaultButton as V1DefaultButton,
  PrimaryButton as V1PrimaryButton,
  CompoundButton as V1CompoundButton,
  IconButton as V1IconButton,
  Dropdown as V1Dropdown,
  TextField as V1TextField,
  Checkbox as V1Checkbox,
  ChoiceGroup as V1ChoiceGroup,
  Label as V1Label,
  Spinner as V1Spinner,
  Link as V1Link,
  SearchBox as V1SearchBox,
  Toggle as V1Toggle,
} from '@fluentui/react';
import { withFluentSwitcher } from '@bingads-webui-react/fluent-version-switcher';

import {
  withSignal,
  CommonEventParser,
  FabricDropdownParser,
} from '@bingads-webui-react/hoc-with-signal';

import {
  DefaultButton as V2DefaultButton,
  PrimaryButton as V2PrimaryButton,
  CompoundButton as V2CompoundButton,
  IconButton as V2IconButton
} from './fluent-v2-controls/button/button';
import { CommandButton as V2CommandButton } from './fluent-v2-controls/button/action-button-shim';
import { DropdownShim } from './fluent-v2-controls/dropdown-shim';
import { TextFieldShim } from './fluent-v2-controls/textfield-shim';
import { CheckboxShim } from './fluent-v2-controls/checkbox-shim';
import { ChoiceGroupShim } from './fluent-v2-controls/choicegroup-shim';
import { LabelShim } from './fluent-v2-controls/label';
import { SpinnerShim } from './fluent-v2-controls/spinner-shim';

initializeIcons();

const ContextualMenuDropdown = props => (
  <ContextualMenu {...props} />
);

export const DefaultButton = withSignal(withFluentSwitcher(V1DefaultButton, V2DefaultButton), { onClick: CommonEventParser });
export const PrimaryButton = withSignal(withFluentSwitcher(V1PrimaryButton, V2PrimaryButton), { onClick: CommonEventParser });
export const CompoundButton = withSignal(withFluentSwitcher(V1CompoundButton, V2CompoundButton), { onClick: CommonEventParser });
export const IconButton = withSignal(withFluentSwitcher(V1IconButton, V2IconButton), { onClick: CommonEventParser });
export const CommandButton = withSignal(withFluentSwitcher(V1CommandButton, V2CommandButton), { onClick: CommonEventParser });
export const Dropdown = withSignal(withFluentSwitcher(V1Dropdown, DropdownShim), { onChange: FabricDropdownParser });
export const TextField = withSignal(withFluentSwitcher(V1TextField, TextFieldShim), { onChange: CommonEventParser });
export const Checkbox = withSignal(withFluentSwitcher(V1Checkbox, CheckboxShim), { onChange: CommonEventParser });
export const ChoiceGroup = withSignal(withFluentSwitcher(V1ChoiceGroup, ChoiceGroupShim), { onChange: CommonEventParser });
export const Label = withSignal(withFluentSwitcher(V1Label, LabelShim), { onClick: CommonEventParser });
export const Spinner = withSignal(withFluentSwitcher(V1Spinner, SpinnerShim), { onClick: CommonEventParser });
export const Link = withSignal(V1Link, {
  onClick: CommonEventParser,
});

export const SearchBox = withSignal(V1SearchBox, {
  onChange: CommonEventParser,
});

export const Toggle = withSignal(V1Toggle, {
  onChange: CommonEventParser,
});

export * from '@fluentui/react';
export { ContextualMenuDropdown as ContextualMenu };
export * from './fluent-v2-controls/with-theme-provider';
